import { render } from "./faq_content.vue?vue&type=template&id=197f2ccc&scoped=true"
import script from "./faq_content.vue?vue&type=script&lang=js"
export * from "./faq_content.vue?vue&type=script&lang=js"

import "./faq_content.vue?vue&type=style&index=0&id=197f2ccc&scoped=true&lang=css"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197f2ccc"]])

export default __exports__